// Apollo
import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// Axios
import axios from 'axios';
import apiService from '@/utils/axios';
// GraphQL
// import InsertTeams from '@/graphql/teams/insert/insertTeams.gql';
import AssignCaptain from '@/graphql/teams/update/assignCaptain.gql';
import DeleteTeam from '@/graphql/teams/delete/deleteTeam.gql';
import InsertPlayerInTeam from '@/graphql/teams/insert/insertPlayerInTeam.gql';
import ToggleTeamBlacklist from '@/graphql/teams/update/toggleTeamBlacklist.gql';
import ToggleTeamStatus from '@/graphql/teams/update/toggleTeamStatus.gql';
import UpdateTeams from '@/graphql/teams/update/updateTeams.gql';
import GetLeagueStatus from '@/graphql/teams/query/GetLeagueStatus.gql';
import GetLeaguebyTeam from '@/graphql/teams/query/GetLeaguebyTeam.gql';
import GetTeamLeagues from '@/graphql/teams/query/GetTeamLeagues.gql'
interface Team {
	id: string;
	name: string;
	captain: string;
	logo_url: string;
	is_active: boolean;
	is_blacklisted: boolean;
	zendesk_id: string;
	player_type: string;
	city: string;
}

export default {
	state: {
		teams: [] as Team[],
	},

	// ================ Getters ================
	getters: {
		teams(state: any) {
			return state.teams.filter((team: any) => {
				return !team.placeholder;
			});
		},

		placeholders(state: any) {
			return state.teams.filter((team: any) => {
				return team.placeholder;
			});
		},
	},

	// ================ Mutations ================
	mutations: {
		setTeams(state: any, teams: any) {
			state.teams = teams;
		},
	},

	// ================= Actions =================
	actions: {
		// =================================================
		// Get all teams from Hasura
		// =================================================

		async getTeams({ commit }: any) {
			const response = await apolloClient.query({
				query: gql`
					query getTeams {
						teams(order_by: { name: asc }) {
							id
							captain
							city
							created_at
							is_active
							is_blacklisted
							logo_url
							name
							placeholder
							player_type
							team_size
							type
							zendesk_id
						}
					}
				`,
				fetchPolicy: 'no-cache',
			});

			const { teams } = response.data;
			commit('setTeams', teams);
		},

		// =================================================
		// Get team from Hasura by ID
		// =================================================

		async getTeamById({ commit, state }: any, { teamId }: any) {
			let _teamId = teamId;
			// if (!_leagueId) _leagueId = state.selectedLeague.id;
            console.log("_teamId", _teamId, teamId)
			const response = await apolloClient.query({
				query: gql`
					query getTeams($_teamId: uuid!) {
						teams(where: { id: { _eq: $_teamId } }) {
							id
							captain
							city
							created_at
							founded
							is_active
							is_blacklisted
							logo_url
							name
							normalized_name
							placeholder
							player_type
							preferred_kick_off_times
							team_size
							type
							updated_at
							zendesk_id
							players_limit
							players: join_players_teams {
								id
								player: playerByPlayer {
									id
									first_name
									last_name
									gender
									ringer
									role
									status
									zendesk_id
									photo_url
								}
							}
							join_team_leagues: league_teams {
								league {
									id
									display_name
									status
									player_type
									team_size
									kick_off_date
									locationObj: locationByLocation {
										id
										name
										city {
											id
											name
										}
									}
								}
							}
							join_team_finals {
								final {
									id
									display_name
									status
									player_type
									team_size
									kick_off_date
									color
									locationObj: locationByLocation {
										id
										name
										city {
											id
											name
										}
									}
								}
							}
						}
					}
				`,
				fetchPolicy: 'no-cache',
				variables: {
					_teamId,
				},
			});

			return response.data.teams[0];

			// const { leagues } = response.data;
			// commit('setSelectedLeague', leagues[0]);

			// return;
		},

		// =================================================
		// Create new team in Hasura
		// =================================================

		async createTeams({ commit, dispatch }: any, teams: any) {
			const response = await apolloClient
				.mutate({
					mutation: gql`
						mutation insert_multiple_teams($objects: [teams_insert_input!]!) {
							insert_teams(objects: $objects) {
								returning {
									id
									captain
									city
									created_at
									is_active
									is_blacklisted
									logo_url
									name
									normalized_name
									placeholder
									preferred_kick_off_times
									player_type
									team_size
									updated_at
									zendesk_id
								}
							}
						}
					`,
					// Parameters
					variables: {
						objects: [...teams],
					},
				})
				.catch(err => {
					console.debug(err);
				});

			await dispatch('getTeams');

			return (response as any).data.insert_teams.returning;
		},

		// =================================================
		// Update a team in Hasura
		// =================================================

		async updateTeam({ dispatch }: any, payload: any) {
			const { id, name, city, player_type, preferred_kick_off_times, team_size } = payload;
			const response: any = await apolloClient
				.mutate({
					mutation: UpdateTeams,
					// Parameters
					variables: {
						teamId: id,
						name,
						city,
						player_type,
						preferred_kick_off_times,
						team_size,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return response.data.update_teams.returning[0];
		},

		// =================================================
		// Update a team in Hasura
		// =================================================

		async updateTeamV2({ dispatch }: any, object: any) {
			const response: any = await apolloClient
				.mutate({
					mutation: gql`
						mutation updateTeamV2($id: uuid!, $object: teams_set_input!) {
							update_teams(where: { id: { _eq: $id } }, _set: $object) {
								affected_rows
							}
						}
					`,
					// Parameters
					variables: {
						id: object.id,
						object,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return response.data;
		},

		// =================================================
		// Assign team captain in Hasura
		// =================================================

		async assignCaptain({ dispatch }: any, payload: any) {
			const { player, team } = payload;
			const response: any = await apolloClient
				.mutate({
					mutation: AssignCaptain,
					// Parameters
					variables: {
						teamId: team,
						captainId: player,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return response.data.update_teams.returning[0];
		},

		// =================================================
		// Register player to teams in Hasura
		// =================================================

		async addPlayerToTeams({ dispatch }: any, { player, team }: any) {
			await apolloClient
				.mutate({
					mutation: InsertPlayerInTeam,
					// Parameters
					variables: {
						team,
						player,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return;
		},

		// =================================================
		// Blacklist team in Hasura
		// =================================================

		async toggleTeamBlacklist({ dispatch }: any, { id, name, is_blacklisted }: HasuraTeam) {
			const isBlacklisted = !is_blacklisted;
			const response: any = await apolloClient
				.mutate({
					mutation: ToggleTeamBlacklist,
					// Parameters
					variables: {
						teamId: id,
						isBlacklisted,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return response.data.update_teams.returning[0];
		},

		// =================================================
		// Blacklist team in Hasura
		// =================================================

		async toggleTeamStatus({ dispatch }: any, { id, is_active }: HasuraTeam) {
			const isActive = !is_active;
			const response: any = await apolloClient
				.mutate({
					mutation: ToggleTeamStatus,
					// Parameters
					variables: {
						teamId: id,
						isActive,
					},
				})
				.catch(err => {
					console.debug(err);
				});

			return response.data.update_teams.returning[0];
		},

		// =================================================
		// Delete team from Hasura
		// =================================================

		async deleteTeam({ dispatch }: any, payload: any) {
			const { id } = payload;
			await apolloClient
				.mutate({
					mutation: DeleteTeam,
					// Parameters
					variables: {
						teamId: id,
					},
				})
				.catch(err => {
					console.log('error in deleting a team', err);
					console.debug(err);
				});

			dispatch('getTeams');
			return;
		},
		async deleteTeamrelationships({ dispatch }: any, payload: any) {
			let id = payload.id;
			console.log('id', id, payload.id);
			await apolloClient
				.mutate({
					mutation: gql`
						mutation deleteTeamRelationships($team_id: uuid) {
							delete_join_league_teams(where: { team_id: { _eq: $team_id } })
							{
								returning {
									id
								}
							}
						}
					`,
					// Parameters
					variables: {
						team_id: id,
					},
				})
				.catch(err => {
					console.log('error in deleting a team relationship', err);
					// console.debug(err);
				});
			return;
		},

		// =================================================
		// Create Placeholders Teams in Hasura
		// =================================================

		async createPlaceholders({ commit }: any, placeholders: any[]) {
			const response = await apolloClient
				.mutate({
					mutation: gql`
						mutation insert_multiple_placeholders($objects: [placeholders_insert_input!]!) {
							insert_placeholders(objects: $objects) {
								returning {
									id
									created_at
									name
									league
									seeding_position
									seeding_group
									type
								}
							}
						}
					`,
					// Parameters
					variables: {
						objects: [...placeholders],
					},
				})
				.catch(err => {
					console.debug(err);
				});

			// await dispatch('getTeams');

			return (response as any).data.insert_placeholders.returning;
		},

		// =================================================
		// Create Placeholders Teams in Hasura
		// =================================================

		async toogleTeamStatus({ commit, dispatch }: any, team: any) {
			if (!team.zendesk_id || team.zendesk_id === 'undefined') return;
			const customer_status = team.is_active ? 'past' : 'current';

			const apiResponse = await axios({
				// url: 'http://localhost:4000/lm/zendesk_contact',
				url: 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/production/lm/zendesk_contact',
				method: 'PUT',
				data: { zendesk_id: team.zendesk_id, data: { customer_status } },
			});

			if (apiResponse.data) {
				await dispatch('updateTeamV2', { id: team.id, is_active: !team.is_active });
			}

			return apiResponse;
		},

		async insertPlayerInTeam({ commit, dispatch }: any, payload: any) {
			const response = await apolloClient.mutate({
				mutation: gql`
					mutation MyMutation($objects: [join_league_teams_insert_input!]!) {
						insert_join_league_teams(objects: $objects) {
							affected_rows
						}
					}
				`,
				variables: {
					objects: payload,
				},
			});

			return response;
		},

		async removeTeam({ commit }: any, payload: any) {
			const { teamId, leagueId } = payload;
			const response = await apolloClient.mutate({
				mutation: gql`
					mutation removeTeamMutation($leagueId: uuid, $teamId: uuid) {
						update_join_league_teams(_set: { deleted_at: "now()" }, where: { team_id: { _eq: $teamId }, _and: { league_id: { _eq: $leagueId } } }) {
							returning {
								id
							}
						}
					}
				`,
				variables: {
					teamId,
					leagueId,
				},
			});
			return response;
		},
		async deleteTeamFromFinal({ commit }: any, payload: any) {
			const { teamId, final_id } = payload;
			try {
				const response = await apolloClient.mutate({
					mutation: gql`
						mutation removeTeamMutation($teamId: uuid, $final_id: uuid) {
							delete_join_team_finals(where: { _and: [{ team: { _eq: $teamId } }, { finals: { _eq: $final_id } }] }) {
								returning {
									id
								}
							}
						}
					`,
					variables: {
						teamId,
						final_id,
					},
				});
				return response;
			} catch (error) {
				return error;
			}
		},

		async deleteMatches({ commit }: any, payload: any) {
			const { teamId, final_id } = payload;
			try {
				const response = await apolloClient.mutate({
					mutation: gql`
						mutation removeTeamMutation($final_id: uuid, $teamId: uuid) {
							update_matches(
								_set: { deleted_at: "now()", deleted_team: $teamId }
								where: { _and: [{ _or: [{ home_team: { _eq: $teamId } }, { away_team: { _eq: $teamId } }] }, { finals_group: { _eq: $final_id } }] }
							) {
								returning {
									id
								}
							}
						}
					`,
					variables: {
						teamId,
						final_id,
					},
				});
				return response;
			} catch (error) {
				return error;
			}
		},

		async addTeamToZendesk(_: any, payload: any) {
			try {
				// const url = 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/dev/lm/create-zendesk-team';
				// const url = 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/Active/lm/create-zendesk-team';
				// const url = 'http://localhost:5000/lm/create-zendesk-team';
				// const { data } = await axios({
				// 	method: 'POST',
				// 	url,
				// 	data: payload.data,
				// });
				// if (process.env.NODE_ENV === 'production' || process.env.DEBUG_ZENDESK ) {
				const { data } = await apiService.post('lm/create-zendesk-team', payload.data);
				return data.data.data;
				// }
			} catch (error) {
				throw new Error('Unable to add team in zendesk');
			}
		},
		async updateTeamInZendesk(_: any, payload: any) {
			try {
				// if (process.env.NODE_ENV === 'production' || process.env.DEBUG_ZENDESK )
				await apiService.put('lm/zendesk_contact', payload);
			} catch (error) {
				return false;
			}
		},
		async updatePlayerInZendesk(_: any, payload: any) {
			try {
				// if (process.env.NODE_ENV === 'production' || process.env.DEBUG_ZENDESK )
				await apiService.post('lm/update_player_status', payload);
			} catch (error) {
				return false;
			}
		},
		async deleteTeamFromZendesk(_: any, zendesk_id: number) {
			try {
				// const url = 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/poduction/lm/remove/contact'; // const url = 'https://vewt6yn7kk.execute-api.eu-central-1.amazonaws.com/poduction/lm/remove/contact';
				// const url = 'http://localhost:5000/lm/remove/contact';
				// await axios({
				// 	url,
				// 	method: 'DELETE',
				// });
				const payload = { zendesk_id };
				await apiService.delete('lm/remove/contact', {
					data: payload,
				});
			} catch (error) {
				console.log('error errors recieved ', error.response, error);
				// throw new Error('Unable to remove team from zendesk');
			}
		},

		async checkTeamStatus(_: any, teamId: string) {
			const { data } = await apolloClient.query({
				query: GetLeagueStatus,
				variables: {
					teamId,
				},
			});
			let newArray :any[] = []
			data.leagues.forEach((val: any,i: any)=>{
				if(val.status !== 'finished'){
					newArray.push(val)
				}
			})
			return newArray 
		},
		async getTeamIDLeagues(_: any,teamId: string){
			console.log("getTeamLeaguesID", teamId)
			const { data } = await apolloClient.query({
				fetchPolicy: 'no-cache',
				query: GetLeaguebyTeam,
				variables: {
					teamId,
				},
			});
			console.log(data.leagues,"leagueIDS byteam player")
			return data.leagues
		},
		async getTeamIDLeagues2(_: any,teamId: string){
			console.log("getTeamLeaguesID2", teamId)
			const { data } = await apolloClient.query({
				query: GetTeamLeagues,
				fetchPolicy: 'no-cache',
				variables: {
					teamId,
				},
			});
			console.log(data.teams[0].league_teams.filter((val: any)=>{
				if(val.league){
					return val.league
				}
			}),"leagueIDS byteam")
			return data.teams[0].league_teams
		}
	},
};
